var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCarrot2 = function SvgCarrot2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 160,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "carrot2_svg__a",
    width: 122,
    height: 115,
    x: 92,
    y: -25,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C4C4C4",
    d: "M92.339-25h121.243V89.027H92.339z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "var(--color-main-text, #EBEBEB)",
    strokeMiterlimit: 10,
    mask: "url(#carrot2_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-main-bg, #090909)",
    d: "M100.985 18.333c-1.515 4.764 1.371 8.516 3.897 9.382 4.042 1.3 5.63-.288 7.867 1.155 2.67 1.732.866 6.279 2.02 11.114 1.227 4.835 6.856 10.465 6.856 10.465l2.093-19.342s1.372-14.217-10.464-18.042c-5.196-1.732-10.465-.36-12.269 5.268Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.697 19.705s13.207 5.34 12.341 27.64"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-main-bg, #090909)",
    d: "M157.205 36.448c-1.515 4.763-6.062 6.134-8.66 5.34-4.042-1.299-4.475-3.536-7.073-3.608-3.175-.144-4.33 4.619-8.155 7.794-3.825 3.176-11.691 4.475-11.691 4.475l9.598-16.888s7.217-12.34 19.053-8.516c5.268 1.588 8.732 5.774 6.928 11.403Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.927 33.633s-13.857-3.392-26.198 15.228"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-main-bg, #090909)",
    d: "M145.225 16.746c2.165-6.784-1.949-14.073-9.093-15.517-5.485-1.154-11.187 1.805-13.424 6.929a12.28 12.28 0 0 0-.577 8.155c.721 2.454.577 5.196-.578 7.433-.216.433-.433.866-.577 1.3-.794 2.38-.433 4.835.722 6.855 1.154 1.949 1.515 4.258 1.154 6.423-.793 5.269-1.154 12.052-1.154 12.052s3.68-5.773 6.134-10.464a9.88 9.88 0 0 1 4.691-4.547 8.57 8.57 0 0 0 4.619-5.124c.144-.433.289-.938.361-1.37.361-2.455 1.732-4.692 3.68-6.207a13.2 13.2 0 0 0 4.042-5.918Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-main-bg, #090909)",
    d: "M100.841 115.04c-2.525-.794-3.897-3.392-3.32-5.918l14.146-55.354c1.227-4.763 6.134-7.505 10.825-5.99a8.453 8.453 0 0 1 5.268 11.187l-20.856 53.116c-.866 2.453-3.609 3.753-6.063 2.959Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m135.266 8.158-12.774 39.62M111.667 53.768l6.207 2.021M119.172 63.222l6.206 2.021M106.831 71.955l6.207 1.948M110.873 84.656l6.207 2.021"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-main-bg, #090909)",
    d: "M111.202 109.274c-1.443-2.165-.938-5.124 1.155-6.712l45.394-34.569c3.897-2.959 9.454-2.02 12.196 2.021 2.743 4.042 1.444 9.599-2.814 12.052l-49.291 28.723a4.877 4.877 0 0 1-6.64-1.515Z"
  }))));
};
export default SvgCarrot2;